<dx-popup *ngIf="this.visible" [visible]="this.visible" title="Add ITM Call" [showTitle]="true" [showCloseButton]="true"
          [width]="480" height="auto" [maxWidth]="'95vw'" [closeOnOutsideClick]="false" (onHiding)="this.close()">
  <div *dxTemplate="let data of 'content'" class="itm-call-form">
    <div class="field symbol-field">
      <div class="label">Underlying Symbol</div>
      <ets-symbol-picker [selectedInstrument]="this.instrument" [showLastPrice]="true"
                         (instrumentSelected)="this.onInstrumentSelected($event)"></ets-symbol-picker>
    </div>
    <div class="field-row contract-details">
      <div class="field expiration-field">
        <div class="label">Expiration</div>
        <dx-select-box [items]="this.expirations" [value]="this.expiration" displayExpr="dateWithDaysToExpiration"
                       [disabled]="this.busy || !this.expirations.length" [placeholder]="this.busy ? 'Loading...' : 'Select Expiration...'"
                       (onValueChanged)="this.onExpirationChanged($event)"></dx-select-box>
      </div>
      <div class="field">
        <div class="label">Strike</div>
        <ets-strikes-dropdown [targetInstrument]="this.instrument" [expiration]="this.expiration"
                             [strike]="this.strike" [disable]="this.busy" [showAtm]="false"
                             (strikeChange)="this.onStrikeChanged($event)"></ets-strikes-dropdown>
      </div>
      <div class="field">
        <div class="label">Price</div>
        <dx-number-box [value]="this.callPrice" [readOnly]="true" [showSpinButtons]="false"
                       format="$ #,##0.00" placeholder="" [inputAttr]="this.centered"></dx-number-box>
      </div>
    </div>
    <div class="field-row">
      <div class="field">
        <div class="label">Contracts</div>
        <dx-number-box [value]="this.contracts" [min]="1" [step]="1" format="#,##0" valueChangeEvent="input change"
                       [showSpinButtons]="true" [useLargeSpinButtons]="true" [inputAttr]="this.centered"
                       (onValueChanged)="this.contracts = $event.value"></dx-number-box>
      </div>
      <div class="field">
        <div class="label">ITM</div>
        <dx-number-box [value]="this.itmPercent" [readOnly]="true" [showSpinButtons]="false" format="#0.00'%'"
                       placeholder="" [inputAttr]="this.centered" [class.invalid]="this.itmPercent !== null && this.itmPercent >= 0"></dx-number-box>
      </div>
    </div>
    <div class="validation" role="status" *ngIf="this.validationMessage">{{ this.validationMessage }}</div>
    <div class="buttons">
      <dx-button [width]="80" text="Cancel" (onClick)="this.close()"></dx-button>
      <dx-button [width]="80" text="Add" type="success" [disabled]="!this.canAdd" (onClick)="this.add()"></dx-button>
    </div>
  </div>
</dx-popup>
